import { Button } from "antd";

const CommonButton = ({
  text,
  htmltype = "button",
  color,
  margintop = "0px",
  onClick = () => {},
  loading = false,
  disabled = false,
}) => {
  return (
    <Button
      loading={loading}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        backgroundColor: disabled ? "#9ca3af" : color, // gray if disabled
        color: "white",
        marginTop: margintop,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
      }}
      className="w-full shadow-none hover:shadow-none focus:shadow-none h-12 border-none rounded-sm text-dynmaicBg2 font-bold font-inter"
      htmlType={htmltype}
    >
      {text}
    </Button>
  );
};

export default CommonButton;
